import { Flex, Grid } from '@chakra-ui/react'
import { FileItem } from '@src/components/FilePreviewList/FileItem'
import { FilePreview } from '@src/components/FilePreview/FilePreview'
import { PaginationComponent } from '@src/components/PaginationComponent/PaginationComponent'
import { usePaginationLogic } from '@src/components/FilePreviewList/usePaginationLogic'
import { observer } from 'mobx-react-lite'
import { FileStatus } from '@src/components/FilePreview/types'
import { useContext } from 'react'
import { MainPageStoreContext } from '@src/pages/MainPageStore'
import { CONCURRENCY_LIMIT } from '@src/constant'
import { useAnalyze } from '@src/pages/hooks/useAnalyze'

interface Props {
    files: FileItem[]
}

export const FilePreviewList = observer((props: Props) => {
    const mainPageStore = useContext(MainPageStoreContext)
    const { store, onPageChange } = usePaginationLogic(props.files)
    const { worker } = useAnalyze()

    const repeatRequest = (file: FileItem) => {
        file.setStatus(FileStatus.WAITING)
        mainPageStore.addFilesToRequest([file])
        if (mainPageStore.activeWorkers < CONCURRENCY_LIMIT) {
            worker()
        }
    }

    return (
        <Flex justify={'space-between'} gap={4}>
            <Grid templateColumns={'repeat(5, 1fr)'} gap={4} width={'100%'}>
                {store.visibleItems.map(file => (
                    <FilePreview
                        key={file.name}
                        file={file}
                        onRemove={() => {
                            file.abortRequest()
                        }}
                        onRepeat={() => {
                            repeatRequest(file)
                        }}
                    />
                ))}
            </Grid>
            <PaginationComponent
                count={store.files.length}
                pageSize={store.pageSize}
                onPageChange={onPageChange}
            />
        </Flex>
    )
})
